title: Medewerker|Medewerkers
fields:
  firstName: Voornaam
  insertions: Tussenvoegsel
  lastName: Achternaam
  email: E-mail
labels:
  numberOfTreatments: "{count} behandeling|{count} behandelingen"
  isAdmin: Mag instellingen aanpassen
tabHeadings:
  treatment: Behandelingen
  openingHour: Werktijden
  permission: Rechten
actions:
  addUser: Medewerker toevoegen
messages:
  manageUsers: Beheer je team en hun rechten
  addUser: Nieuwe medewerker toevoegen
  addUserDescription: Voeg een nieuwe medewerker toe aan je team.
  noTreatmentsAssigned: Geen behandelingen toegewezen
  userRights: "Rechten van deze medewerker:"
  configureWorkingHours: "Stel de werktijden per dag in:"
  configureTreatments: "Selecteer welke behandelingen deze medewerker kan uitvoeren:"
  remove: Medewerker verwijderen
  removeInfo: Weet je zeker dat je deze medewerker wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
  baseWorkingHoursOnOpeningHours: Werkdagen en openingstijden van salon overnemen
